// Short forms of the lookups the form code repeats on every render
export const byId = (id) => document.getElementById(id);
export const all = (selector, root = document) => root.querySelectorAll(selector);

// The forms render different parts, so a missing element is skipped
export function setText(id, text) {
    const el = byId(id);
    if (el) el.textContent = text;
}
